export const lamapiPath = '/lamapi/public';
export const wikiPath = '/wiki/read';
export const slimPath = '/php';
export const nodePath = '/jsajax';
export const oldApi = '/ajax';
